
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0af11b8474c7020b7aec71dc7b57c6e2.jpg"
          alt="AI Technology Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/70 to-navy/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="inline-block mb-6 px-4 py-2 bg-gold/10 border border-gold/20 rounded-md">
          <span className="text-gold text-base font-semibold">AI Training &amp; Consulting for Northwest Georgia</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-white">
          Future-Proof Your Business
          <br />
          <span className="text-gold">With AI Solutions</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/70 mb-12 max-w-3xl mx-auto leading-relaxed">
          Evernorth AI helps local organizations learn how to use AI confidently in their daily work. We focus on clear training, simple workflows, and real tasks your team already handles.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://calendly.com/evernorthai/discovery"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-gold text-white font-semibold rounded-full hover:bg-[#a68a4e] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Schedule a 15-Minute Discovery Call
          </a>
          <a
            href="mailto:info@evernorthai.com"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/20 transition-all border border-white/30 cursor-pointer whitespace-nowrap"
          >
            Not Ready To Talk? Email Us!
          </a>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-2">10+</div>
            <div className="text-sm text-white/50">Years Operations Experience</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-2">3</div>
            <div className="text-sm text-white/50">Core Service Offerings</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-2">8+</div>
            <div className="text-sm text-white/50">Cities Served in NW Georgia</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-2">100%</div>
            <div className="text-sm text-white/50">Practical AI Training</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('services')}
          className="text-white/60 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
